import type { TranslationTree } from '../../types';

export const administration: TranslationTree = {
  administration: {
    tabs: { members: 'Membres', companies: 'Entreprises' },
    retry: 'Réessayer',
    roles: { user: 'Utilisateur', admin: 'Administrateur', superAdmin: 'Super-administrateur' },
    errors: {
      generic: 'Une erreur est survenue. Veuillez réessayer.',
    },
    members: {
      search: 'Rechercher par e-mail ou nom…',
      roleFilter: 'Filtrer par rôle',
      companyFilter: 'Filtrer par entreprise',
      allRoles: 'Tous les rôles',
      allCompanies: 'Toutes les entreprises',
      colMember: 'Membre',
      colRole: 'Rôle',
      colCompany: 'Entreprise',
      colAccess: 'Accès',
      colLastLogin: 'Dernière connexion',
      colActions: 'Actions',
      empty: 'Aucun membre pour l’instant — ajoutez le premier.',
      you: 'vous',
      noModules: 'Aucun module',
      actions: 'Ouvrir les actions du membre',
      locked: 'Compte protégé',
      lockedSuper: 'Les comptes super-administrateur sont gérés via la CLI — protégés',
      lockedScope: 'Géré par un super-administrateur',
    },
    member: {
      addTitle: 'Ajouter un membre',
      addSubtitle: 'Créez un nouveau compte pour cette instance.',
      editTitle: 'Modifier le membre',
      add: 'Ajouter un membre',
      save: 'Enregistrer',
      edit: 'Modifier',
      resetPassword: 'Réinitialiser le mot de passe',
      delete: 'Supprimer',
      email: 'E-mail',
      password: 'Mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom',
      role: 'Rôle',
      roleHint: 'Le super-administrateur est géré via la CLI et ne peut pas être défini ici.',
      company: 'Entreprise',
      access: 'Accès aux modules',
      deleteTitle: 'Supprimer le membre',
      deleteBody:
        'Cela supprime définitivement {{email}} et ses accès. Cette action est irréversible.',
      confirmDelete: 'Supprimer le membre',
    },
    reset: {
      title: 'Réinitialiser le mot de passe',
      body: 'Définissez un nouveau mot de passe pour {{email}}.',
      newPassword: 'Nouveau mot de passe',
      confirm: 'Réinitialiser le mot de passe',
    },
    companies: {
      search: 'Rechercher des entreprises…',
      new: 'Nouvelle entreprise',
      empty: 'Aucune entreprise pour l’instant — créez la première.',
      colCompany: 'Entreprise',
      colMembers: 'Membres',
      colActions: 'Actions',
      members: '{{count}} membres',
      rename: 'Renommer',
      delete: 'Supprimer',
    },
    company: {
      createTitle: 'Nouvelle entreprise',
      renameTitle: 'Renommer l’entreprise',
      name: 'Nom de l’entreprise',
      create: 'Créer l’entreprise',
      save: 'Enregistrer',
      deleteTitle: 'Supprimer « {{name}} »',
      deleteBody: 'Cette entreprise compte {{count}} membres. Choisissez ce qu’il advient d’eux.',
      reassignOption: 'Réaffecter les membres, puis supprimer',
      reassignDesc: 'Déplacez tous les membres vers une autre entreprise, puis supprimez celle-ci.',
      reassignTarget: 'Déplacer les membres vers',
      cascadeOption: 'Supprimer l’entreprise et ses membres',
      cascadeDesc:
        'Supprime définitivement cette entreprise et tous les comptes membres. Irréversible.',
      warning:
        'Les comptes super-administrateur et votre propre compte ne sont jamais supprimés — le serveur le bloque. Si cette entreprise en détenait un, la suppression en cascade est refusée.',
      reassignConfirm: 'Réaffecter et supprimer',
      cascadeConfirm: 'Tout supprimer',
    },
  },
};
